import { en } from './dictionaries/en';
import { ar } from './dictionaries/ar';
import { ckb } from './dictionaries/ckb';
import type { Dictionary } from './dictionaries/en';
import type { Locale } from './config';

export type { Dictionary, Locale };
export * from './config';
export { localizeProject } from './localizeProject';

const dictionaries: Record<Locale, Dictionary> = { en, ar, ckb };

export function getDictionary(locale: Locale): Dictionary {
  return dictionaries[locale] ?? en;
}
